/* src/app/modules/unauthenticated/privacy/privacy.component.css */
h3 {
  margin-top: 50px;
}
/*# sourceMappingURL=privacy.component-Y5EWMPB3.css.map */
